import React, { useState, useContext, useRef } from 'react'
import {
  Grid,
  FormHelperText,
  TextField,
  InputAdornment,
  Divider,
  Select,
  MenuItem,
  Paper,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import { BrowserView, isMobile, MobileView } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { Controller, useForm } from 'react-hook-form'
import { ReactComponent as CompanyLogoSvg } from '../../../assets/company-logo.svg'
import { ReactComponent as CameraIconSvg } from '../../../assets/camera_add.svg'
import { ReactComponent as CameraChangeSvg } from '../../../assets/change-photo.svg'
import { ReactComponent as HelmetSvg } from '../../../assets/helmet.svg'
import { DatePicker, KeyboardDatePicker } from '@material-ui/pickers'
import { isOver18, awaitWithLoading, capitalizeFirstLetter, capitalizeAllLetters } from '../../../services/utils'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { SessionContextStore } from '../../../context/SessionContext'
import { OptionalTag } from '../../Core/OptionalTag'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import '../UserProfile.css'
import { ACTIONS, UserProfileContextStore } from '../../../context/UserProfileContext'
import { Action } from '../../../models/Action'
import UserProfileModel from '../../../models/user-models/UserProfileModel'
import { SessionService } from '../../../services/SessionService'
import { UserApi } from '../../../api/user.api'
import { SkyElementHoverPopover } from '../../Core/Popover/SkyPopover'
import { ProfilePicturePopover } from '../../Core/Popover/ProfilePicturePopover'
import { useLocation } from 'react-router-dom'
import EventIcon from '@material-ui/icons/Event'
import InfoIcon from '@material-ui/icons/Info'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { EMAIL_REGEX } from '../../../Constants'
import { GlobalTextField } from '../../Core/Input/ControlledTextField'
import { generalPhoneNumberRegex } from '../../../services/utils'

const dayjs = require('dayjs')

export const UserSection = props => {
  const location = useLocation()
  const context = useContext(UserProfileContextStore)
  const sessionContext = useContext(SessionContextStore)
  const { register, watch, triggerValidation, setValue, errors, control, getValues } = useForm(
    SessionService.isLoggedIn()
      ? {
          defaultValues: {
            fname: sessionContext.user.firstName,
            lname: sessionContext.user.lastName,
            company_name: sessionContext.user.company,
            dob: sessionContext.user.dateOfBirth,
            phone_number: sessionContext.user.phoneNumber,
            email: sessionContext.user.email,
            // dob_checkbox: isOver18(sessionContext.user.dateOfBirth),
          },
          mode: 'onChange',
        }
      : { mode: 'onChange' }
  )
  const [img, setImg] = useState(sessionContext.user.profilePicture)
  const profilePicture = useRef(null)
  const lnameWatch = watch('lname', sessionContext.user.lastName)
  const fnameWatch = watch('fname', sessionContext.user.firstName)
  const companyNameWatch = watch('social_security_number', sessionContext.user.socialSecurityNumber)
  const phoneNumberWatch = watch('phone_number', sessionContext.user.phoneNumber)
  const emailWatch = watch('email', sessionContext.user.email)
  const validatePhoneNumber = phoneNumber => !phoneNumber || generalPhoneNumberRegex.test(phoneNumber)
  const uploadProfilePicture = () => profilePicture.current.click()

  const onProfilePictureSelected = async event => {
    setImg(URL.createObjectURL(event.target.files[0]))
    let res = await awaitWithLoading(UserApi.saveProfilePicture(event.target.files[0]))
    if (res.ok) {
      EventEmitterService.dispatch(EventKey.USER_PROFILE_IMAGE_UPDATED, { url: res.data.image_url })
      EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Picture saved successfully' })
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(EventKey.USER_PROFILE_SAVE, async () => {
      let valid = await triggerValidation()
      if (valid) {
        context.dispatch(new Action(ACTIONS.SAVE_USER_INFO, getValues()))
      }
    })

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
    }
  }, [])

  React.useEffect(() => {
    setValue('fname', capitalizeAllLetters(sessionContext.user.firstName))
    setValue('lname', capitalizeAllLetters(sessionContext.user.lastName))
    setValue('company_name', sessionContext.user.company)
    setValue('dob', sessionContext.user.dateOfBirth)
    setValue('phone_number', sessionContext.user.phoneNumber)
    setValue('email', sessionContext.user.email)
    // setValue('dob_checkbox', isOver18(sessionContext.user.dateOfBirth))
    setImg(sessionContext.user.profilePicture)
  }, [sessionContext.user])

  return (
    <React.Fragment>
      <BrowserView>
        <FlexView vAlignContent={'center'}>
          <HelmetSvg className="margin-right-6 medium-icon" />
          <div className="text-title blue bold">Owner Details</div>
        </FlexView>
        <Divider />
        <div className="text-small-title black bold margin-bottom-basic">Personal Details</div>
      </BrowserView>

      <Grid container spacing={3}>
        {/* <Grid item>
                        <div className="company-logo-container" onClick={uploadProfilePicture}>
                        <SkyElementHoverPopover popOver={<ProfilePicturePopover />}>
                            {!img ? 
                            <React.Fragment>
                                <CompanyLogoSvg />
                                <div className="company-logo-text gray bold text-body">Company Logo</div>
                                </React.Fragment>
                            : <img className="company-logo-img" src={img}/>}
                            </SkyElementHoverPopover>

                            <div className="camera-box clickable" >
                                {!img ? <CameraIconSvg /> : <CameraChangeSvg />}
                            </div>
                        </div>
                    </Grid> */}
        <Grid item xs={12} md={4}>
          <GlobalTextField
            fullWidth
            label="First name"
            name="fname"
            register={register}
            autoComplete="given-name"
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={errors}
            helperText={!!errors.fname && 'Required'}
            inputRef={register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <GlobalTextField
            fullWidth
            label="Last name"
            name="lname"
            register={register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={errors}
            helperText={!!errors.lname && 'Required'}
            inputRef={register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            as={
              <KeyboardDatePicker
                disableFuture
                fullWidth
                keyboardIcon={<EventIcon className="backbuttongray" />}
                openTo="year"
                views={['year', 'month', 'date']}
                label={'Date of Birth'}
                error={!!errors.dob}
                inputVariant="outlined"
                helperText={!!errors.dob ? 'Must be 18 or older' : ''}
                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
              />
            }
            onChange={date => {
              if (date && date.length > 0 && date[0] != null) {
                setValue('dob', new Date(date[0]))
                return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
              } else {
                setValue('dob', null)
                return getValues()['dob']
              }
            }}
            rules={{ validate: tim => isOver18(new Date(tim)), required: true }}
            name="dob"
            value={watch('dob')}
            defaultValue={watch('dob')}
            control={control}
          />
        </Grid>
        {isMobile && (
          <>
            <div className="text-title bold black margin-top-medium margin-left-12">Contact Details</div>
            <Grid container spacing={3} className="margin-top-medium margin-bottom-small margin-left-3 margin-right-6">
              <Grid item xs={12} md={4}>
                <GlobalTextField
                  fullWidth
                  label="Mobile number"
                  name="phone_number"
                  inputRef={register({ required: true, validate: validatePhoneNumber })}
                  register={register}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  errors={errors}
                  helperText={!!errors.phone_number && (errors.phone_number.type == 'required' ? 'Required' : 'Invalid phone number')}
                />
                <div className="disclaimer avenir-book">
                  By providing your phone number, you agree to receive text messages from Voom. Message and data rates may apply. We never
                  sell your data or share personal details in any promotional way.
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <GlobalTextField
                  disabled={SessionService.isLoggedIn()}
                  isrequired={true}
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  register={register}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  errors={errors}
                  inputRef={register({ required: true, pattern: { value: EMAIL_REGEX, message: 'Invalid email address' } })}
                  helperText={!!errors.email && (errors.email.type == 'required' ? 'Required' : 'Invalid email address')}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
      {!isMobile && (
        <>
          <Divider />
          <div className="text-small-title black bold">Contact Details</div>
          <Grid container spacing={3} className="margin-top-small">
            <Grid item xs={12} md={4}>
              <GlobalTextField
                fullWidth
                inputRef={register({ required: true, validate: validatePhoneNumber })}
                label="Mobile number"
                name="phone_number"
                validate={validatePhoneNumber}
                register={register}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                errors={errors}
                helperText={!!errors.phone_number && (errors.phone_number.type == 'required' ? 'Required' : 'Invalid phone number')}
              />
              <div className="disclaimer avenir-book">
                By providing your phone number, you agree to receive text messages from Voom. Message and data rates may apply. We never
                sell your data or share personal details in any promotional way.
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <GlobalTextField
                disabled={SessionService.isLoggedIn()}
                isrequired={true}
                fullWidth
                label="Email"
                name="email"
                type="email"
                register={register}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                errors={errors}
                inputRef={register({ required: true, pattern: { value: EMAIL_REGEX, message: 'Invalid email address' } })}
                helperText={!!errors.email && (errors.email.type == 'required' ? 'Required' : 'Invalid email address')}
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* <div className="text-small-title black bold margin-bottom-basic margin-top-basic">Social security number</div>
                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item xs={12} md={6}>
                        <TextField InputLabelProps={{ shrink: !!companyNameWatch }} 
                                fullWidth variant="outlined" 
                                type='number'
                                label="Social Security Number" 
                                name="social_security_number" 
                                InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} 
                                inputRef={register} error={!!errors.social_security_number} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FlexView vAlignContent={'center'}>
                            <InfoIcon className='gray margin-right-6' />
                            <div className='text-small gray'>The Social Security Number allows us to give you a more accurate quote. if you prefer not to provide this information, leave this field blank</div>
                        </FlexView>
                    </Grid>
                </Grid> */}
      {/* <MobileView>
                    <div>
                        <FlexView vAlignContent={'center'}>
                            <div className="company-logo-container">
                                {!img ? 
                                <React.Fragment>
                                    <CompanyLogoSvg />
                                    <div className="company-logo-text gray bold text-body">Company Logo</div>
                                    </React.Fragment>
                                : <img className="company-logo-img" src={img}/>}

                                <div className="camera-box clickable" onClick={uploadProfilePicture}>
                                    {!img ? <CameraIconSvg /> : <CameraChangeSvg />}
                                </div>
                            </div>
                            <div>
                                <Paper elevation={3} className="logo-popover-container">
                                    <div className="logo-popover-inner">
                                        <div className="text-small black">Your logo will appear on your certificate of insurance</div>
                                    </div>
                                </Paper>
                                <FlexView className="margin-top-medium space-between logo-popover-container" vAlignContent={'center'}>
                                    <div onClick={uploadProfilePicture} className="text-small blue underline clickable">Upload Photo</div>
                                    <OptionalTag />
                                </FlexView>
                            </div>
                        </FlexView>
                        <div className="text-small gray margin-bottom-basic margin-top-basic">This name will appear on your certificate of insurance and policy</div>
                        <TextField InputLabelProps={{ shrink: !!fnameWatch }} fullWidth variant="outlined" className="margin-top-small" label="First name" name="fname" autoComplete="given-name" autoFocus inputRef={register({required: true})} error={!!errors.fname} />
                        <TextField InputLabelProps={{ shrink: !!lnameWatch }} fullWidth variant="outlined" className="margin-top-basic" label="Last name" name="lname" autoComplete="family-name" inputRef={register({required: true})} error={!!errors.lname} />
                        <TextField InputLabelProps={{ shrink: !!phoneNumberWatch }} 
                                fullWidth variant="outlined" 
                                label="Phone number" 
                                className="margin-top-basic" 
                                name="phone_number" 
                                inputRef={register({validate: validatePhoneNumber})}
                                autoComplete="tel" 
                                error={!!errors.phone_number}
                                helperText={!!errors.phone_number? 'Invalid phone number' : ''}
                                autoFocus 
                                InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} 
                                />
                        <TextField InputLabelProps={{ shrink: !!companyNameWatch }} fullWidth variant="outlined" className="margin-top-basic" label="Company name" name="company_name" InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} inputRef={register} error={!!errors.company_name} />
                        <Controller
                            name="dob_checkbox"
                            as={<FormControlLabel  
                                    className="margin-top-basic"
                                    control={<Checkbox color="primary" />}
                                    label={<div className='text-body'>I confirm that the operating pilot(s) is 18 years old or over</div>} />}
                            control={control}
                            rules={{ required: true }}/>
                        {!!errors.dob_checkbox && <FormHelperText error>Must be over 18</FormHelperText>}
                    </div>
            </MobileView>
            <input type='file' accept="image/*" id='file' onChange={onProfilePictureSelected} ref={profilePicture} style={{display: 'none'}}/> */}
    </React.Fragment>
  )
}
